import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, CardMedia, Typography, Box } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Image from "../common/Image";
import noImageUrl from "../../img/no_image.jpg";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '30rem',
    margin: '0 auto',
    border: '2px solid #aaa',
    width: '95%',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[4],
      cursor: 'pointer'
    }
  },
  media: {
    height: 0,
    paddingTop: '75%', // 4:3 aspect ratio
    position: 'relative',
    backgroundColor: '#000',
    '& img': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  },
  content: {
    padding: theme.spacing(2),
    flexGrow: 1
  },
  name: {
    fontWeight: 600,
    fontSize: '1.8rem',
    marginBottom: theme.spacing(2),
    color: '#3298dc',
    lineHeight: 1.3
  },
  addressContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1)
  },
  locationIcon: {
    color: '#ff3860',
    fontSize: '1.2rem',
    marginRight: theme.spacing(1)
  },
  address: {
    color: theme.palette.text.secondary
  }
}));

const BusinessProfileCard = props => {
  const classes = useStyles();
  const { user } = props;

  const renderImage = avatar => {
    return (
      <CardMedia className={classes.media}>
        <Image src={avatar ? avatar.image_url : noImageUrl} size={'512'} alt="avatar" />
      </CardMedia>
    );
  };

  return (
    <Card className={classes.root}>
      {renderImage(user.profile.avatar)}
      <CardContent className={classes.content}>
        <Typography variant="h5" component="h3" className={classes.name}>
          {user.name}
        </Typography>
      </CardContent>
    </Card>
  );
};

BusinessProfileCard.propTypes = {
  user: PropTypes.object
};

export default BusinessProfileCard;
